var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUserSmal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#00AEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C4 18.75 7 18.75 8.5 17.25C9.25 16.5 7 16.5 7 12.75C7 10.2503 7.99975 9 10 9C12.0003 9 13 10.2503 13 12.75C13 16.5 10.75 16.5 11.5 17.25C13 18.75 16 18.75 16 21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C15.567 18.6092 15.803 18.571 16.5074 18.2318C17.058 17.9665 17.5893 17.6659 18.0053 17.25C18.7553 16.5 16.5053 16.5 16.5053 12.75C16.5053 10.2503 17.505 9 19.5053 9C21.5055 9 22.5053 10.2503 22.5053 12.75C22.5053 16.5 20.2553 16.5 21.0053 17.25C22.5053 18.75 25.5053 18.75 25.5053 21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUserSmal);
export default __webpack_public_path__ + "static/media/manage-user-smal.2bd798eba5138bd355bea565041238c4.svg";
export { ForwardRef as ReactComponent };